import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useScrollFreeze } from '@hooks/useScrollFreeze';
import SwitchLink from '../links/switchLink';
import cx from 'classnames';

import { InstantSearch, Configure } from 'react-instantsearch-dom';
import { CustomSearchBox } from '@components/search/customSearchBox';
import { SearchHits } from '@components/search/searchHits';
import { searchClient } from '@lib/algolia';

import Vector from '@svg/vector.svg';
import VectorBack from '@svg/vectorback.svg';

const variants = {
  open: {
    opacity: 1,

    transition: {
      duration: 0.3,
      when: 'beforeChildren',
      staggerChildren: 0.2,
    },
  },
  closed: {
    opacity: 0,
    transition: {
      duration: 0.3,
    },
  },
};

const menuVars = {
  open: {
    opacity: 1,
    transition: {
      duration: 0.7,
    },
  },
  closed: {
    opacity: 0,
    transition: {
      duration: 0.3,
    },
  },
};

const aboutVars = {
  open: {
    rotate: 90,
    transition: {
      duration: 0.3,
    },
  },
  closed: {
    rotate: 0,
    transition: {
      duration: 0.3,
    },
  },
};

const NavInner = ({ navOpen, setNavOpen, serviceLinks, mainMenu }) => {
  useScrollFreeze();
  const [exploreMore, setExploreMore] = useState(false);
  const [aboutMenu, setAboutMenu] = useState(false);
  const [searchActive, setSearchActive] = useState(false);

  return (
    <motion.div
      key={navOpen}
      initial='closed'
      animate='open'
      exit='closed'
      variants={variants}
      className='fixed top-0 left-0 w-full bg-green-tint z-50'>
      <div
        className={cx('h-screen w-full grid grid-cols-1   pt-28 pb-10', {
          'grid-rows-[1fr_5fr]': !searchActive,
          'grid-rows-1': searchActive,
        })}>
        <div
          onClick={() => setSearchActive(true)}
          className=' px-gutter bg-green-tint overflow-y-auto '>
          <InstantSearch searchClient={searchClient} indexName='globalSearch'>
            <Configure hitsPerPage={600} />
            <CustomSearchBox placeholder='Search' />

            {searchActive && <SearchHits />}
          </InstantSearch>
        </div>
        <div className='grid grid-cols-14 '>
          {/* initial menu */}
          {!exploreMore && !aboutMenu && !searchActive && (
            <div className='col-start-2 lg:col-start-3 col-end-14 lg:col-end-10  space-y-10   '>
              {serviceLinks?.map((item, i) => (
                <motion.div variants={menuVars} className='text-blue blockH7'>
                  <SwitchLink
                    {...item}
                    key={i}
                    className='transition-all ease-in-out duration-400'
                    onClick={() => setNavOpen(false)}
                  />
                </motion.div>
              ))}
              <motion.div
                variants={menuVars}
                className='text-blue blockH7 flex justify-between items-center cursor-pointer'
                onClick={() => setExploreMore(true)}>
                <p>Explore more</p>
                <Vector className='svg-green' />
              </motion.div>
            </div>
          )}
          {/* Explore more menu */}
          {exploreMore && (
            <div className='col-start-2 lg:col-start-3 col-end-14 lg:col-end-10 grid grid-cols-1 self-stretch  gap-y-3 lg:gap-y-4 '>
              <motion.div
                variants={menuVars}
                className='text-green blockH7 flex items-center cursor-pointer'
                onClick={() => setExploreMore(false)}>
                <VectorBack className='mr-6 svg-green' />
                <p>Services</p>
              </motion.div>
              {mainMenu?.map((item, i) => (
                <motion.div
                  variants={menuVars}
                  className='text-blue blockH7   cursor-pointer'
                  onClick={() => {
                    setAboutMenu((prev) => !prev);
                    // setExploreMore(false);
                  }}>
                  <div className='flex justify-between items-center'>
                    <SwitchLink
                      {...item.mainLink}
                      key={i}
                      className='transition-all ease-in-out duration-400'
                      onClick={() => setNavOpen(false)}
                    />
                    {item.subLinks && (
                      <motion.div
                        variants={aboutVars}
                        initial='closed'
                        animate={aboutMenu ? 'open' : 'closed'}>
                        <Vector className='svg-green' />
                      </motion.div>
                    )}
                  </div>

                  <AnimatePresence>
                    {item.subLinks && aboutMenu && (
                      <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: '100px' }}
                        exit={{ opacity: 0, height: 0 }}
                        className='overflow-hidden flex flex-col '
                        transition={{
                          duration: 0.5,
                        }}>
                        {mainMenu[0]?.subLinks?.link?.map((item, i) => (
                          <SwitchLink
                            {...item}
                            key={i}
                            className='transition-all ease-in-out duration-400 text-blue mt-5 pl-4'
                            onClick={() => setNavOpen(false)}
                          />
                        ))}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              ))}
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export const NavModal = ({ navOpen, setNavOpen, serviceMenu, mainMenu }) => {
  return (
    <AnimatePresence exitBeforeEnter>
      {navOpen && (
        <NavInner
          navOpen={navOpen}
          setNavOpen={setNavOpen}
          serviceLinks={serviceMenu}
          mainMenu={mainMenu}
        />
      )}
    </AnimatePresence>
  );
};
